import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import './App.css';
import Header from './components/common/header/Header';
import Sidebar from './components/common/sidebar/Sidebar';
import { SidebarProvider } from './context/SidebarContext';
import AppRoutes from './routes';
import './styles/appStyles.css';  

const AppContent = () => {
  const location = useLocation();
  const isLoginPage = location.pathname === '/';
  const isLandingPage = location.pathname === '/dashboard';

  return (
    <SidebarProvider>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <div className="App">
          {!isLoginPage && <Header />}
          <div className={`container ${(isLoginPage || isLandingPage) ? 'login-container' : ''}`}>
            {(!isLoginPage && !isLandingPage) && <Sidebar />}
            <AppRoutes />
          </div>
        </div>
      </LocalizationProvider>
    </SidebarProvider>
  );
};

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
